import createChallengeImage from "@/assets/images/create-challenge.jpg";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const CreateChallengeCard: FC<{
  children: React.ReactNode;
  image?: string | null;
}> = ({ children, image }) => {
  const { t } = useTranslation();
  return (
    <div className="group relative flex min-h-[476px] flex-1 flex-col justify-end overflow-hidden rounded-2xl p-4 text-white sm:h-[520px] md:p-6">
      <div
        className="absolute inset-0 z-0 scale-100 transition-transform duration-500 ease-in-out group-hover:scale-110"
        style={{
          background: `linear-gradient(0deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.40) 100%), url(${image ?? createChallengeImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      <div className="relative z-10">
        {children}
        <Button size="lg" className="w-fit" asChild>
          <Link to="/community-challenge" search={{ tab: "", source: "coh" }}>
            {t("landingPage.createChallenge")}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default CreateChallengeCard;
